import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { truncateFloat } from "../../../../helpers/generalHelper";



const CardProjectFiche = ({ children, className = "", title = "", classNameHeader = "", buttonExtra = <></>, enableButtonExtra = true }) => {
    return (
        <div className={`bg-white rounded-md p-4 flex flex-col gap-4 ${className}`}>
            <div className={`w-full h-[20px] overflow-hidden flex items-center gap-4 ${classNameHeader}`}>
                <p className="text-[12px] font-bold">{title}</p>
                {enableButtonExtra && <>{buttonExtra}</>}
            </div>
            {children}
        </div>
    );
};
const icons = {
    Planeación: iconsDetailsProyect.planning,
    "Diseño UI/UX": iconsDetailsProyect.design,
    "Arte 3D": iconsDetailsProyect.art3d,
    "Programación Web": iconsDetailsProyect.webunity,
    "Programación Unity": iconsDetailsProyect.webunity,
    Testing: iconsDetailsProyect.webunity,
};

export const AreasVisualInfo = ({ color = "", label = "", value = 0 }) => {
    return (
        <div className="w-[104px] h-[32px] grid justify-center items-center grid-cols-[24px,calc(100%-24px)]">
            <div className="h-[24px] w-[24px] rounded-full flex justify-center items-center " style={{ backgroundColor: color }}>
                <img src={icons[label]} alt={`icon ${label}`} />
            </div>
            <div className="w-full h-full pl-2">
                <div className=" w-full h-full overflow-hidden flex flex-col">
                    <span className="text-[12px] font-[#282828] font-bold">{truncateFloat(value)}</span>
                    <span className="text-[7px] font-[#282828] font-normal ">{label}</span>
                </div>
            </div>
        </div>
    );
};

export default CardProjectFiche;
